import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { UsersService } from '../../users/users.service';
import { BaseService } from '../../shared/base.service';
import { HomeService } from '../home.service';
import { MaintenanceService } from '../../maintenance/maintenance.service';
import { AppService } from '../../app.service';
import { UserModel } from '../../users/user.model';
import { HomeComponent } from '../home.component';
import { MaintenanceComponent } from '../../maintenance/maintenance.component';
import { UsersComponent } from '../../users/users.component';
import { TranslateService } from '@ngx-translate/core';
import { DialogComponent } from '../../dialog/dialog.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ClinicsService } from '../../clinics/clinics.service';
import * as moment from 'moment';
import { SecureApi } from '../../core/secure.api';
import { IMyDpOptions } from 'mydatepicker';

@Component({
    selector: 'system-admin-component',
    templateUrl: './system-admin.component.html',
    styleUrls: [
        '../home.component.scss',
        './system-admin.component.scss'
    ],
    providers: [UsersService, BaseService, HomeService, MaintenanceService, MaintenanceComponent]
})

export class SystemAdminComponent extends HomeComponent implements OnInit {

    @ViewChild('usersComponent', { static: false }) usersComponent: UsersComponent;
    @ViewChild('downloadDialog', { static: false }) downloadDialog: DialogComponent;
    @ViewChild('exportModal',  {static: false}) exportModal: ModalDirective;

    patients: Object[];

    activeLang: Object;
    openModal = false;
    clinics: Object[];
    invoiceFilters = {
        clinic_id : 0,
        year : 0,
        month : 0
    };
    years = [];
    months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    dateFormat: string = 'DD.MM.YYYY';
    today = new Date();
    dpkDueDateOptions: IMyDpOptions = {
        dateFormat: 'dd.mm.yyyy',
        showTodayBtn: false,
        componentDisabled: false,
        disableUntil: {
            year: this.today.getFullYear(),
            month:  this.today.getMonth(),
            day:  this.today.getDate()
        }
    };
    showModalSetting = false;

    constructor(public authService: AuthService,
        public router: Router,
        public translate: TranslateService,
        public fb: FormBuilder,
        public baseService: BaseService,
        public appService: AppService,
        public usersService: UsersService,
        public homeService: HomeService,
        public clinicService: ClinicsService,
        public maintenanceService: MaintenanceService,
        public secureApi: SecureApi,
        public maintenanceComponent: MaintenanceComponent) {
        super(authService, router, translate, baseService, appService, usersService);
    }

    ngOnInit() { 
        super.ngOnInit();
        this.searchInfo = new UserModel();
        this.url = 'home';
        this.activeLang = this.appService.languages[0];
        
        let currentYear = moment().year();
        for (let i = currentYear; i >= 2017; i--) {
            this.years.push(i);
        }
    }

    exportUser(e) {
        this.token = this.authService.user['token'];
        e.target.blur();
        e.target.parentElement.blur();
        window.location.href = this.authService.baseUrl + 'retrieve-data/users?token=' + this.token;
    }

    exportClinic(e) {
        this.token = this.authService.user['token'];
        e.target.blur();
        e.target.parentElement.blur();
        window.location.href = this.authService.baseUrl + 'retrieve-data/clinics?token=' + this.token;
    }

    exportPatient(e) {
        e.target.blur();
        e.target.parentElement.blur();
        let params = {
            icon: 'fas fa-info',
            warning: false
        };
        let dialog = this.downloadDialog.openAlert(params);
        dialog.onSubmit(() => {
            return;
        });

        dialog.showAlert('The file is created in the background. Meanwhile you can keep on working with the system.');
        this.baseService.secureApi.get('retrieve-data/patients')
            .subscribe(response => {
                this.appService.getFileDownload();
            });
    }

    exportFile(e, type) {
        this.token = this.authService.user['token'];
        e.target.blur();
        e.target.parentElement.blur();
        let params = {
            icon: 'fas fa-info',
            warning: false
        };
        let dialog = this.downloadDialog.openAlert(params);
        dialog.onSubmit(() => {
            return;
        });

        dialog.showAlert('The file is created in the background. Meanwhile you can keep on working with the system.');
        this.secureApi.post('retrieve-data/' + type, {
            filters: JSON.stringify(this.invoiceFilters)
        }, false).subscribe(response => {
            this.appService.getFileDownload();
            this.exportModal.hide();
        });
    }

    openExportModal(params: Object) {
        this.initForm(params);
        if (params['url'] && params['url'] !== "") {
            this.url = params['url'];
        }

        let item: any;
        const disabled = false;

        this.clinicService.getAll()
            .subscribe(
                response => {
                    this.clinics = response['items'];
                    // prevent users from clicking outside to close the modal since that does not set the url correctly
                    this.exportModal.config.backdrop = false;
                    this.exportModal.config.ignoreBackdropClick = true;
                    this.exportModal.config.keyboard = false;
                    // this ensures the form is displayed only when the data is ready
                    this.isLoading = false;
                    this.isUpdated = false;
                    this.exportModal.show();
                });

    }

    setFilter(params){
        return params;
    }

    toggleMaintenance() {
        this.form.value.value = !this.form.value.value;
    }

    toggleNotification() {
        this.form.value.show_release_notification = !this.form.value.show_release_notification;
    }

    toggleDowntimeNotification() {
        this.form.value.show_downtime_notification = !this.form.value.show_downtime_notification;
    }

    /**
     * @param params
     */
    openFormModal(params: Object) {
        this.initForm(params);

        if (params['url'] && params['url'] !== "") {
            this.url = params['url'];
        }

        this.maintenanceService.read(params['id'])
            .subscribe(
                response => {
                    let item = response['maintain'] || [];
                    let notification = response['notification'] || [];
                    let downtimeNotification = response['downtime_notification'] || [];
                    let releaseDate = response['release_date'] || [];
                    let releaseNotificationTextEN = response['release_notification_text_en_GB'] || [];
                    let releaseNotificationTextDE = response['release_notification_text_de_CH'] || [];
                    let releaseNotificationTextFR = response['release_notification_text_fr_FR'] || [];
                    let releaseNotificationTextIT = response['release_notification_text_it_IT'] || [];
                    let form = {};
                    let disabled = params['action'] === 'read' ? true : false;

                    if (item.hasOwnProperty('text')) {
                        form['text'] = { value: item['text'], disabled: disabled };
                    }
                    if (item.hasOwnProperty('value')) {
                        form['value'] = item['value'];
                    }

                    if (notification && notification.hasOwnProperty('value')) {
                        form['new_feature_notification'] = notification['value'];
                    }

                    if (downtimeNotification && downtimeNotification.hasOwnProperty('value')) {
                        form['show_downtime_notification'] = downtimeNotification['value'];
                    }

                    if (releaseDate && releaseDate.hasOwnProperty('text') && releaseDate['text'] != '') {
                        let date = moment(releaseDate['text'], this.dateFormat);
                        form['release_date'] =  {
                            date: {
                                day: date.format('D'),
                                month: date.format('M'),
                                year: date.format('Y')
                            },
                            formatted: releaseDate['text']
                        };
                    } else {
                        form['release_date'] = '';
                    }

                    if (releaseNotificationTextEN.hasOwnProperty('text')) {
                        form['release_notification_text_en_GB'] = releaseNotificationTextEN['text'];
                    }

                    if (releaseNotificationTextDE.hasOwnProperty('text')) {
                        form['release_notification_text_de_CH'] = releaseNotificationTextDE['text'];
                    }

                    if (releaseNotificationTextFR.hasOwnProperty('text')) {
                        form['release_notification_text_fr_FR'] = releaseNotificationTextFR['text'];
                    }

                    if (releaseNotificationTextIT.hasOwnProperty('text')) {
                        form['release_notification_text_it_IT'] = releaseNotificationTextIT['text'];
                    }

                    if (this.form != null) {
                        this.form.reset(form);
                    } else {
                        this.form = this.fb.group(form);
                    }

                    this.initDateCalendarSetting();
                    this.showModal();
                });
    }

    submitSetting(data, valid) {
        if (data['release_date'] && data['release_date'].formatted) {
            data['release_date'] = data['release_date'].formatted;
        } else {
            data['release_date'] = '';
        }
        this.submit(data, valid, 'settings')
    }

    initDateCalendarSetting(): void {
        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);

        this.dpkDueDateOptions.disableUntil.year = +yesterday.getFullYear();
        this.dpkDueDateOptions.disableUntil.month = +yesterday.getMonth() + 1;
        this.dpkDueDateOptions.disableUntil.day = +yesterday.getDate();
    }

    handleAddUser() {
        this.usersComponent.openFormModal({ action: 'create', title: 'Add User', url: '/home' });
    }
}
